import { useState, createContext } from "react";

export const SideDrawerContext = createContext({
  collapsed: false,
  collapse: () => {},
  deCollapse: () => {},
});

const SideDrawerContextProvider = (props) => {
  const [collapsed, setCollapsed] = useState(false);

  const collapse = () => {
    setCollapsed(true);
  };

  const deCollapse = () => {
    setCollapsed(false);
  };

  return (
    <SideDrawerContext.Provider value={{ collapsed, collapse, deCollapse }}>
      {props.children}
    </SideDrawerContext.Provider>
  );
};

export default SideDrawerContextProvider;
